import { Injectable } from '@angular/core';
import { columnsModel } from '../models/customer.model';
import { RootScopeService } from './root-scope.service';
import { MatTableDataSource } from '@angular/material/table';
import { IHModel } from '../models/IHConstants';
import * as Constants from '../models/Constants';
import moment, { duration } from 'moment';
import { CustomerAccountBusinessLogicService } from './customer-account-business-logic.service';
import { BehaviorSubject, of } from 'rxjs';
import _, { clone } from 'lodash';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ECHILD } from 'constants';


interface ExampleFlatNode {
  [k: string]: any;
  expandable: boolean;
  name: string;
  count: any;
  level: number;
}

interface FoodNode {
  name: string;
  count?: any;
  children?: FoodNode[];
}

@Injectable({
  providedIn: 'root',
})
export class InteractionHistoryService {

  public dataSource = new BehaviorSubject<any>([]);
  selectedRow: any;
  isFilterApplied = new BehaviorSubject<boolean>(false);

  private transformer = (node: any, level: number) => {
    //console.log("servcie transforner called", node)
    //console.log("servcie transforner called", level)
    return {
      expandable: !!node.children && node.children.length > 0,
      channelIcon: node.channelIcon,
      agent: node.agent,
      date: node.date,
      title: node.title,
      level: level
    };
  };

  treeControl = new FlatTreeControl<any>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );
  /**Holds brief view Table Data  */
  interHistBriefViewTableData = new MatTableDataSource([]);

  /**Holds list view Table Data  */
  interHistListViewTableData = new MatTableDataSource([]);

  isAdditionlAccntCasePresent: boolean = false;

  /**
   * @author: Pooja Gupta
   * Below Map maintains mapping of the icons for the respective
   * channel field of IH Object
   */
  channelIconMap = {
    [Constants.IH_CALL]: {
      [Constants.IH_EXTERNAL_CALL]: 'fa-light fa-phone-arrow-down-left',
      [Constants.IH_INTERNAL_CALL]: 'fa-light fa-phone-arrow-up-right',
    },
    // CCR1-3360
    [Constants.IH_CHAT]: 'fa-light fa-comment-lines',
    Lisa: 'fa-light fa-message-lines',
    IVR: 'fa-light fa-headset',
    Web: 'fa-light fa-globe',
    Mobile: 'fa-light fa-mobile',
    Message: 'fa-light fa-messages',
    additionAcnt: 'fa-light fa-user',

    // added for CCR1-2830
    [Constants.IH_Document]: {
      [Constants.IH_OUTBOUND_DOCUMENT]: 'fa-light fa-file-export',
      [Constants.IH_INBOUND_DOCUMENT]: 'fa-light fa-file-import',
    },

    Email: 'fa-light fa-envelope',
    Text: 'fa-light fa-messages',
    TRANSFERRED_ICON : 'fa-sharp fa-solid fa-t',
  };

  /**Map [{id : [tableData]}]
   * Its used to store brief view table data for respective customer account
   * Id .Basically used for retaining the data on Tab switch
   * and if data is already present no seperate hit will be made.
   * @author : Pooja Gupta
   * Value of each object
   *    can be  - a) tableData
   *             b) "apiFailed" - If api fails
   *             c) blank tableData - if api success but no data available
   */
  IHBriefViewDataCAMap: any = {};
  IHListViewDataCAMap: any = {};
  IHListFilterViewDataCAMap: any = {};
  IHSelectedRow = {};

  public Columns: columnsModel[] = [
    { field: 'channelIcon', header: 'Channel', width: 10 },
    { field: 'date', header: 'Date', width: 20 },
    { field: 'startTime', header: 'Start/Rcvd Time', width: 20 },
    { field: 'topic', header: 'Topic/Title/Subject', width: 30 },
    { field: 'agent', header: 'Agent', width: 20 },
    
    
  ];

  /**
   * Object to create with List view IH header
   * @param listViewColumns = [array of IH List header]
   * @author :Amarjeet
   */
  public listViewColumns: columnsModel[] = [
    { field: 'channelIcon', header: 'Channel', width: 5 },
    { field: 'date', header: 'Date', width: 15 },
    { field: 'startTime', header: 'Start/Rcvd Time', width: 5 },
    { field: 'topic', header: 'Topic/Title/Subject', width: 45 },
    { field: 'agent', header: 'Agent', width: 20 },
    //{ field: 'mood', header: 'Mood', width: 10 }, 
    { field: 'conversationId', header: 'Conversation ID', width: 10 },
    { field: 'mood', header: 'mood', width: 20 },
    
  ];
  treeData: any[] = [];
  showAlightTableComponent: boolean = false;
  arr: any[] = [];
  toDelete: any[] = [];
  additionalAccntEntry: any[] = [];


  constructor(public rootScope: RootScopeService) { }

  /**
   * Method dealing with data of briew view IH
   * @param interHistData = [array of IH 5 record]
   * @author : Pooja Gupta
   */

  modifyIHBriefViewData(interHistData) {
    this.modifyResponseData(interHistData, 'briefView');
    this.interHistBriefViewTableData = new MatTableDataSource(interHistData);
    this.IHBriefViewDataCAMap[this.rootScope.activeCustTab.customerSessionId] =
      this.interHistBriefViewTableData;
  }

  /**
   * Method dealing with data of List view IH
   * @param interHisListData = [array of IH List object]
   *
   */
  modifyIHListViewData(data, selectedRow?, self?) {

    this.transferredDataArr = [];
    /** added as part of CCR1-3055   ***/
    let interHisListData = _.cloneDeep(data);

    /** Sorting is needed in order to get first mapped additionalaccount entry to parent IH Object data 
     * Story - CCR1-3858
     ***/
    interHisListData.sort(function (a, b) {
      return new Date(b.begin).valueOf() - new Date(a.begin).valueOf();
    });

    /**Below method gives primary caller mapped with additonal acocuntIH */
    this.modifyResponseData(interHisListData, 'listView'); 

    /**Now below method will identify Primary and transferred IH */
    this.modifyDataForTransferredData(interHisListData,selectedRow);
    
  }


  



 

/**
 * Below method mapped now Primary and transferredIH
 * @param data 
 * @param selectedRow 
 * @author :Pooja Gupta
 */
  modifyDataForTransferredData(data , selectedRow){
    /**Reason for cloning , sorting on the same in vice versa was not working .It ws getting overridden */
    let clonedData = _.cloneDeep(data);
    clonedData.sort(function (a, b) {
      return new Date(a.begin).valueOf() - new Date(b.begin).valueOf();
    });
    let that = this;
    clonedData.map(function(each){
      that.checkForParentTransferredOrConfObj(each)
    })

    this.createDataForTreeTableComponent(data, selectedRow, self);
  }




  

  /**
   * 
   * @param interHisListData 
   * @param selectedRow 
   * @param self 
   * Below method creates tree type data structure for listview IH
   * whenevr response arry contains any of addition account node.
   * As per requirement CCR1-1158.- Original req
   * Modified Req - CCR1-3858 - where chils id transferred IH not additional account IH
   * @author : Pooja Gupta
   */
  createDataForTreeTableComponent(interHisListData, selectedRow?, self?) {
    this.treeData = [];
    this.dataSource.next([]);
    let that = this;

    /** Pushing other than call /chats IH to treeData (documents and msg) ***/
    interHisListData.map(function(each){
      if (each.documentDetail == null) { /**Case 1: IH of documents and messages */
          that.treeData.push(each);
      }
    })

     /** Pushing Primary /Transferred call /chats IH to treeData in parent child structure ***/
    this.transferredDataArr.map(function(each){
      if(each?.transferedData && each?.transferedData?.length > 0){
        let arr:any[] = [];
        each.transferedData.map(function(eachTransferredIH){
          if(eachTransferredIH._id != each._id){
            
            if(eachTransferredIH.channel == Constants.conversion.call)
              eachTransferredIH.title = 'Transfered Call';
            else if(eachTransferredIH.channel == Constants.conversion.chat)
              eachTransferredIH.title = 'Transfered Chat';

            eachTransferredIH.channelIcon = that.channelIconMap['TRANSFERRED_ICON'];
            arr.push(eachTransferredIH);
          }
        })

        // let arrOfEndTime = _.map(each['transferedData'], 'end');
        // arrOfEndTime.sort(function (a, b) {
        //   return new Date(b).valueOf() - new Date(a).valueOf();
        // });
        // each.documentDetail.end = arrOfEndTime[0];
        each['children'] = arr;
        that.treeData.push(each);
      }
    })


      /**Pushing Additional Accounts call /chats IH whose parenr is unknown to treeData in parent child structure ***/
    if(this.additionalAccntEntry.length > 0){
      this.additionalAccntEntry.map(function(each){
        each.channelIcon = that.channelIconMap.additionAcnt;
        each.title = Constants.ADDITIONAL_ACNT_TOOLTIP;
        each.topic = Constants.DO_NOT_DISCUSS;
        that.treeData.push(each);
      })
    }

    this.treeData.sort(function (a, b) {
      return new Date(b.begin).valueOf() - new Date(a.begin).valueOf();
    });
    
    //let childParentNodePresent = _.find(this.treeData, function (each) { return ((each?.children) && (each?.children?.length > 0)) })
    // if (childParentNodePresent) {
      // tree table data with parent child node(with additional account)
    //  this.setAlightTreeTable(self, selectedRow);
      // let primaryNode = _.find(this.treeData, function (each) {
      //   return each._id == selectedRow?.row?._id;
      // })

      // if (self?.alightTreeTable) {
      //   // console.log("selectedObj", selectedObj)
      //   self.alightTreeTable.selectedRow = primaryNode ? primaryNode : this.treeData[0];
      //   self.selectedRowDetailView = primaryNode ? primaryNode : this.treeData[0];
      // }


      this.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId] = this.treeData;
      this.showAlightTableComponent = false;
      this.dataSource.next(this.treeData);

    // }
    // else {
    //   // normal common table data with additional accounts 
    //   this.showAlightTableComponent = true;
    //   let data: any = this.treeData;
    //   this.interHistListViewTableData = new MatTableDataSource(data)
    //   this.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId] = this.interHistListViewTableData

    // }


  }

  /**
   * 
   * @param self - Below method identifies row selected in brief view and 
   * identify from treeData structure to make it selected when view in List View.
   * @param selectedRow  - Object of selected object in brief view
   * @author : Pooja Gupta
   */
  setAlightTreeTable(self: any, selectedRow: any) {
    let that = this;
    let primaryNode;
    let selectedObj;
    if (selectedRow && selectedRow?.row) {
      console.log("selectedRow?.row?._id)",selectedRow?.row?._id)
      /**If selectedRow is parent or primary node */
      for(let i = 0 ; i < this.treeData.length ; i++){
        let each = this.treeData[i];
        if(each._id == selectedRow?.row?._id){
          selectedObj = each;
          this.rootScope.activeCustTab.agenInteractionData.currentRowNumber = i;
          break;
        }
      }
    }

    setTimeout(() => {
      console.log("selectedObj", selectedObj)
      if (self?.alightTreeTable) {
        console.log("selectedObj", selectedObj)
        self.alightTreeTable.selectedRow = selectedObj ? selectedObj : this.treeData[0];
        self.selectedRowDetailView = selectedObj ? selectedObj : this.treeData[0];
        this.IHListViewDataCAMap[this.rootScope.activeCustTab.customerSessionId]['selectedRow'] = {'row' : self.alightTreeTable.selectedRow};
        
        self.IHListViewLoader = false;
        self.showLoaderMsg = false;
        //Set Pagination based on row
        const currentRowNumber = this.rootScope.activeCustTab.agenInteractionData?.currentRowNumber;
        const pageSize = self?.alightTreeTable?.pageSize;

        if (currentRowNumber && pageSize) {
          const currentPage = Math.ceil(currentRowNumber / pageSize);
          self?.alightTreeTable?.setPage(currentPage);
        }
        this.rootScope.agenIneractionData.isAgentRowClicked=false;
        // console.log(" self.alightTreeTable.selectedRow", self.alightTreeTable.selectedRow)
      }
    }, 500);
  }



  /**
   * Method to modify the response as per UI needs 
   * @param interHistData = [array of IH object]
   * @author :Pooja Gupta
   */
  modifyResponseData(interHistData, dataType) {
    let that = this;
    let counter = 0;
    this.additionalAccntEntry = [];

    interHistData.map(function (each) {

      each.agent = each.delegate?.name;

      if (each.agent === undefined) {
        each.agent = "N/A";
      }
      each.channelIcon = that.channelIconMap[each.channel];
      // each.topic = "Absence Management";
      each.topic = each.description;
      each.title = each.channel;
      each.end = each.documentDetail?.end;
      each.date = that.getIHDate(each.begin);
      each.startTime = that.getTime(each.begin);
      each.mood = that.getMoodValue(each);

      if (each.channel == Constants.conversion.call && each.initiated) {  //CCR1-3264
        if (each.subject?.id == each.contact?.id) {
          each.channelIcon = each.channelIcon[each.initiated];
          /*If call is Inbound call ,initiated field value = EXTERNAL and vice versa **/
          if (each.initiated == Constants.IH_INTERNAL_CALL) {
            each.title = 'Outbound Call';
          } else each.title = 'Inbound Call';
        }
        else {  //CCR1-3264 Handling Additional Accounts on Main IH Card
          each.channelIcon = that.channelIconMap.additionAcnt;
          each.title = Constants.ADDITIONAL_ACNT_TOOLTIP;
          let searchId = that.rootScope.activeCustTab.id;
          each.topic = searchId == each.subject.id ? Constants.DO_NOT_DISCUSS : each.description;
        }
      }

      if (each.channel == Constants.conversion.chat) {
        if (each.subject?.id == each.contact?.id) {
          each.channelIcon = that.channelIconMap.chat;
          each.title = 'Chat';
        }
        else {
          each.channelIcon = that.channelIconMap.additionAcnt;
          each.title = Constants.ADDITIONAL_ACNT_TOOLTIP;
          let searchId = that.rootScope.activeCustTab.id;
          each.topic = searchId == each.subject.id ? Constants.DO_NOT_DISCUSS : each.description;
        }
      }

      if (each.channel == 'Document') {
        each.channelIcon = each.channelIcon[each.initiated];
        each.startTime = each.time;

        if (each.initiated == Constants.IH_INBOUND_DOCUMENT) {
          each.title = 'Inbound Document';

        } else {
          each.title = 'Outbound Document';
        }
      }

      if (dataType == 'listView' && each.documentDetail != null) {
        each.conversationId = each.documentDetail?.externalRefId;
        /** Added for story CCR1-3858 **/
        that.modifyDataForAdditionAlAccount(each);
      
      }
    });
  }


  getMoodValue(each){
    let obj = _.find(each?.documentDetail?.buckets, (each) => {
      return each?.keyName == Constants.WRAP_UP_KEY_BUCKET;
    })

     if(obj){
       return obj?.keyValue.interactionFeedback;
     }
     else{
       return '';
     }

  }


  /**
   * Below method mapped additional IH to its primary IH as an array of object
   * PrimaryIH['additionalAccountsData'] = AdditionIHArr.
   * Story :CCR1-3858
   * @param each IH
   * @author :Pooja
   */
  modifyDataForAdditionAlAccount(each){
    if (each.documentDetail?.subject['id'] == each.documentDetail.contact['id']) {  /**checking entry is not additional account **/
      if(this.additionalAccntEntry.length > 0){
         let arr :any[] = _.cloneDeep(this.additionalAccntEntry);
         let arr2 = _.filter(arr,function(addAcnt){
            return addAcnt?.conversationId == each.conversationId;
          })
          each['additionalAccountsData'] = arr2 ;
        }
        /*Letting only those additional account entry in array whose parent is unknown which will used in final data structure created***/
       this.additionalAccntEntry = this.additionalAccntEntry.filter(item => (item.conversationId != each.conversationId ));
       
    }
    else{
      /** Entry is of additional account since array is sorted on basis of time ****/
      this.additionalAccntEntry.push(each);
       
    }
  }

  /**
   * In below method iterating over raw data and identifying
   * which entries are for transferred call and storing in other array"transferredDataArr"".
   * and one who has transfered the call should have the data to whom he has transferred the call .So 
   * for it a field called ,"transferedData" is created which is an array of objects.
   * @param each 
   */
  transferredDataArr: any[] = [];

  checkForParentTransferredOrConfObj(each) {
    if (each.documentDetail != null && each.documentDetail?.subject['id'] == each.documentDetail.contact['id']) {  /**checking entry is not additional account **/
      let obj = _.find(this.transferredDataArr, function (each1) { return each1.conversationId == each.conversationId })
      if (!obj) {
        let temp = _.cloneDeep(each);
        let newArr: any = [];
        newArr.push(temp)
        each['transferedData'] = newArr;
        this.transferredDataArr.push(each);
      }
      else {
        /**If flow comes here it means current entry is transferred obj and array already has IH entry who has transfeerd the call */
        let arr: any[] = []
        if (obj?.transferedData && obj.transferedData?.length > 0 )
          obj['transferedData'].push(each);
        else {
          arr.push(each);
          obj['transferedData'] = arr;
        }
      }
    }
  
  }


  getIHDate(date) {
    if (date) return moment(date).format('MMM-DD-YYYY');
    else return 'NA';
  }

  getTime(time) {
    time = moment(time).format('hh:mm a');
    let len = time.length;
    return time.substring(0, len - 1) + '.' + time.substring(len - 1) + '.';
  }

  clearRetainedDataOfCA() {
    this.interHistBriefViewTableData = new MatTableDataSource([]);
    this.interHistListViewTableData = new MatTableDataSource([]);
  }

  /**
   * Method to show selection IH List view
   * @param totalCount = no. of records
   * @param selectedBriefListRow = selected row from brief view list
   * @author :Amarjeet
   */
  setTableData(self, totalCount, selectedBriefListRow) {
    let index;
    self.totalRecords = totalCount;

    if (selectedBriefListRow && selectedBriefListRow?.row) {
      index = this.interHistListViewTableData.data.find(
        (x: any) => x._id == selectedBriefListRow.row._id
      );
    }
    setTimeout(() => {
      if (self.alightTable) {
        self.alightTable?.setGridSortAndPagination();
        self.alightTable.selectedRow =
          selectedBriefListRow && selectedBriefListRow.row
            ? index
            : this.interHistListViewTableData.data[0];
      }
    }, 10);

  }

  /**
   *
   * @param tabId
   * Method used to delete entry in Maps
   * on account closure.
   * @author : Pooja Gupta
   */
  deleteEntryIHMap(tabId) {
    delete this.IHBriefViewDataCAMap[tabId];
    delete this.IHListViewDataCAMap[tabId];
    delete this.IHListFilterViewDataCAMap[tabId];
  }

  /**
   * Method to calculate duration of call
   * @param startTime
   * @param endTime
   * @author :Pooja Gupta
   */
  getDuration(startTime, endTime) {
    const start = new Date(startTime).getTime();
    const end = new Date(endTime).getTime();

    const diff = end - start;
    const seconds = diff / 1000;
    let sec = seconds % 60;
    let min = (seconds - sec) / 60;
    if (isNaN(min)) min = 0;

    if (isNaN(sec)) sec = 0;

    let minutes = '';
    let secnds = '';
    sec = Math.floor(sec);

    if (min < 10 || sec < 10) {
      if (min < 10) minutes = '0' + min;
      else minutes = min + '';

      if (sec < 10) secnds = '0' + sec;
      else secnds = sec + '';

      return minutes + ':' + secnds;
    }

    return min + ':' + sec;
  }


  setWrapUpDefaultValue(){
    if(this.rootScope.activeCustTab.wrapUpData.interactionMode == 'NA'){
    if (this.rootScope.activeCustTab.activeCall) {
      if (
        this.checkInboundCall() &&
        !this.rootScope.istransferred &&
        !this.rootScope.isConference) {
        this.rootScope.activeCustTab.wrapUpData.interactionMode = 'Inbound';
      } else if (!this.checkInboundCall() && !this.rootScope.isCallBackCall) {
        this.rootScope.activeCustTab.wrapUpData.interactionMode = 'Outbound';
      } else if (!this.checkInboundCall() && this.rootScope.isCallBackCall) {
        this.rootScope.activeCustTab.wrapUpData.interactionMode = 'Inbound';
      } else if (this.checkInboundCall() && this.rootScope.istransferred) {
        this.rootScope.activeCustTab.wrapUpData.interactionMode = 'Transferred';
      } else if (this.checkInboundCall() && this.rootScope.isConference) {
        this.rootScope.activeCustTab.wrapUpData.interactionMode = 'Transferred';
      }
    }

    else if (this.rootScope.activeCustTab.activeChat && !this.rootScope.activeCustTab.isChatTransferred) {
      this.rootScope.activeCustTab.wrapUpData.interactionMode = 'Inbound';
      }
    else if(this.rootScope.activeCustTab.activeChat && this.rootScope.activeCustTab.isChatTransferred){
        this.rootScope.activeCustTab.wrapUpData.interactionMode = 'Transferred';
    }
    }
  }

  checkInboundCall() {
    if (
      this.rootScope.activeCustTab.activeCall &&
      this.rootScope.callType == Constants.INBOUND_CALL_TYPE
    ) {
      return true;
    } else {
      return  false;
    }
  }

 
}